export const watchControl = {
    bind(el, binding, node) {

        el.addEventListener('keyup', (e) => {
            const currentVal = node.elm.value;
            binding.value(currentVal);
        });
    },
};
